module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-225.90249113.jpg";